/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent } from 'react';
import { SubmitButton } from '../../pages/common/forms/SubmitButton';
import { ConnectedDialog } from '../ConnectedDialog';
import { useDispatch } from 'react-redux';
import { closeDialog } from '../../../app/dialog/dialog.actions';
import { AnnualAndPeriodsForm } from '../../pages/common/forms/AnnualForm';
import { useSelectWithParams } from '../../../utils/selector.utils';
import { dialogSelectors } from '../../../app/dialog/dialog.selectors';
import { IAnnualAndPeriodsFormDialogProps } from './types';

export const AnnualAndPeriodsFormDialog: FunctionComponent = () => {
  const dispatch = useDispatch();
  const props = useSelectWithParams(
    dialogSelectors.selectDialogProps,
    'annualAndPeriodsFormDialog',
  ) as IAnnualAndPeriodsFormDialogProps;

  const onClose = () => {
    dispatch(closeDialog('annualAndPeriodsFormDialog'));
  };

  return (
    <ConnectedDialog dialogKey="annualAndPeriodsFormDialog">
      <div>
        <div className="panel w500">
          <div className="panel-header small-header flex jcsb">
            <h3 className="f-2">Add Annual / Periods</h3>
            <span className="close-popup close" onClick={onClose}>
              <i className="icon-close" />
            </span>
          </div>
          <div className="panel-body">
            <AnnualAndPeriodsForm {...props} />
          </div>
          <div className="panel-footer no-border flex jcr">
            <a className="link blueGray mr-2 close" onClick={onClose}>
              Close
            </a>
            <SubmitButton
              apiKey={props?.annual ? 'updateAnnualApi' : 'createAnnualApi'}
              formName="annuals-form"
              text="Send"
            />
          </div>
        </div>
      </div>
    </ConnectedDialog>
  );
};
